<template>
  <HeaderComponent />

  <div class="wrapper">
    <main class="main">
      <div class="container">
        <section class="hero section">
          <div class="hero__content">
            <img class="hero__img-top" src="/static/img/logo/logo.png" alt="">
            <h1 class="hero__title">Школа <span class="accent">ответственного владельца</span></h1>
            <p class="hero__text">Создана для тех, кто принимает на&nbsp;себя ответственность за&nbsp;заботу о&nbsp;собаке или кошке и&nbsp;удовлетворение ее&nbsp;потребностей на&nbsp;протяжении всей ее&nbsp;жизни.</p>
            <router-link
              to="/quiz"
              class="btn hero__btn"
              onclick="sendEventYM(
                 102182679,
                 'start_learning_click_btn'
               );"
            >
              Начать обучение
            </router-link>
          </div>
          <div class="hero__img">
            <picture>
              <source srcset="/static/img/landing/cover.webp" type="image/webp">
              <img src="/static/img/landing/cover.png" alt="Обложка">
            </picture>
          </div>
        </section>
        <section class="points section">
          <div class="points__item">
            <p class="points__text">
              Узнайте больше о&nbsp;правильном уходе за&nbsp;питомцем через <span class='accent'>интерактивные образовательные тесты</span>
            </p>
            <img class="points__img" src="/static/img/landing/graph-1.png" alt="">
          </div>
          <div class="points__item">
            <p class="points__text">
              Получите Сертификат ответственного владельца&nbsp;и <span class='accent'>персональную скидку &minus;15% на&nbsp;покупку корма и&nbsp;аксессуаров для вашего питомца в&nbsp;сети зоомагазинов &laquo;Зоозавр&raquo;</span>. «<a class='accent' href="https://zoozavr.ru/" target="_blank">Зоозавр</a>» — один из лидеров в России по количеству зоомагазинов, обеспечивающий владельцев доступом к качественным товарам для питомцев
            </p>
            <img class="points__img" src="/static/img/landing/graph-2.png" alt="">
          </div>
        </section>
        <section class="section banner-2">
          <a
            href="https://royalcanin.ru/vetification?utm_campaign=2025Q3-rc-ru-other-healthyPet-healthyPet&utm_source=healthyPet&utm_medium=x-partner-healthyPet&utm_content=banner-healthyPet"
            target="_blank"
            onclick="sendEventYM(
             102182679,
             'make_vet_appointment_click_banner'
           );"
          >
            <picture>
              <source
                media="(max-width: 1200px)"
                srcset="/static/img/banner-health-check_mob.webp 1x, /static/img/banner-health-check_mob@2x.webp 2x"
                type="image/webp"
              >
              <source
                media="(max-width: 1200px)"
                srcset="/static/img/banner-health-check_mob.jpg 1x, /static/img/banner-health-check_mob@2x.jpg 2x"
                type="image/jpeg"
              >

              <source
                media="(min-width: 1200px)"
                srcset="/static/img/banner-health-check.webp 1x, /static/img/banner-health-check@2x.webp 2x"
                type="image/webp"
              >
              <source
                media="(min-width: 1200px)"
                srcset="/static/img/banner-health-check.jpg 1x, /static/img/banner-health-check@2x.jpg 2x"
                type="image/jpeg"
              >
              <img
                src="/static/img/banner-health-check.jpg"
                alt=""
              >
            </picture>
          </a>
        </section>
        <section class="themes section">
          <h2 class="section-title">Темы</h2>
          <div class="themes__cards">
            <div class="themes__card">
              <div class="themes__top">
                <div class="themes__icons">
                  <div class="icon--rounded icon--filled">
                    <svg class="icon-cat">
                      <use xlink:href="/static/img/sprites/sprite.svg#cat"></use>
                    </svg>
                  </div>
                  <div class="icon--rounded icon--filled">
                    <svg class="icon-dog">
                      <use xlink:href="/static/img/sprites/sprite.svg#dog"></use>
                    </svg>
                  </div>
                </div>
              </div>
              <h3 class="themes__title">ПОЯВЛЕНИЕ ПИТОМЦА В ДОМЕ</h3>
              <picture class="themes__img">
                <source srcset="/static/img/landing/game-1.webp" type="image/webp">
                <img src="/static/img/landing/game-1.png" alt="ПОЯВЛЕНИЕ ПИТОМЦА В ДОМЕ">
              </picture>
            </div>
            <div class="themes__card">
              <div class="themes__top">
                <div class="themes__icons">
                  <div class="icon--rounded icon--filled">
                    <svg class="icon-cat">
                      <use xlink:href="/static/img/sprites/sprite.svg#cat"></use>
                    </svg>
                  </div>
                  <div class="icon--rounded icon--filled">
                    <svg class="icon-dog">
                      <use xlink:href="/static/img/sprites/sprite.svg#dog"></use>
                    </svg>
                  </div>
                </div>
              </div>
              <h3 class="themes__title">социализация</h3>
              <picture class="themes__img">
                <source srcset="/static/img/landing/game-2.webp" type="image/webp">
                <img src="/static/img/landing/game-2.png" alt="социализация">
              </picture>
            </div>
            <div class="themes__card">
              <div class="themes__top">
                <div class="themes__icons">
                  <div class="icon--rounded icon--filled">
                    <svg class="icon-cat">
                      <use xlink:href="/static/img/sprites/sprite.svg#cat"></use>
                    </svg>
                  </div>
                  <div class="icon--rounded icon--filled">
                    <svg class="icon-dog">
                      <use xlink:href="/static/img/sprites/sprite.svg#dog"></use>
                    </svg>
                  </div>
                </div>
              </div>
              <h3 class="themes__title">Питание</h3>
              <picture class="themes__img">
                <source srcset="/static/img/landing/game-3.webp" type="image/webp">
                <img src="/static/img/landing/game-3.png" alt="Питание">
              </picture>
            </div>
            <div class="themes__card">
              <div class="themes__top">
                <div class="themes__icons">
                  <div class="icon--rounded icon--filled">
                    <svg class="icon-cat">
                      <use xlink:href="/static/img/sprites/sprite.svg#cat"></use>
                    </svg>
                  </div>
                  <div class="icon--rounded icon--filled">
                    <svg class="icon-dog">
                      <use xlink:href="/static/img/sprites/sprite.svg#dog"></use>
                    </svg>
                  </div>
                </div>
              </div>
              <h3 class="themes__title">важность профилактики</h3>
              <picture class="themes__img">
                <source srcset="/static/img/landing/game-5.webp" type="image/webp">
                <img src="/static/img/landing/game-5.png" alt="важность профилактики">
              </picture>
            </div>
            <div class="themes__card">
              <div class="themes__top">
                <div class="themes__icons">
                  <div class="icon--rounded icon--filled">
                    <svg class="icon-cat">
                      <use xlink:href="/static/img/sprites/sprite.svg#cat"></use>
                    </svg>
                  </div>
                  <div class="icon--rounded icon--filled">
                    <svg class="icon-dog">
                      <use xlink:href="/static/img/sprites/sprite.svg#dog"></use>
                    </svg>
                  </div>
                </div>
              </div>
              <h3 class="themes__title">ВАЖНОСТЬ ПОСЕЩЕНИЯ ВЕТЕРИНАРНОГО ВРАЧА</h3>
              <picture class="themes__img">
                <source srcset="/static/img/landing/game-4.webp" type="image/webp">
                <img src="/static/img/landing/game-4.png" alt="ВАЖНОСТЬ ПОСЕЩЕНИЯ ВЕТЕРИНАРНОГО ВРАЧА">
              </picture>
            </div>
          </div>
        </section>
        <div class="landing-group">
          <section class="game section">
            <div class="section-title">Игра</div>
            <div class="game__img game__img-1">
              <picture>
                <source srcset="/static/img/avatar/unhappy.webp" type="image/webp">
                <img src="/static/img/avatar/unhappy.png" alt="">
              </picture>
            </div>
            <div class="game__img game__img-2">
              <picture>
                <source srcset="/static/img/avatar/happy.webp" type="image/webp">
                <img src="/static/img/avatar/happy.png" alt="">
              </picture>
            </div>
            <div class="game__question">
              <div class="quiz-question">
                <div class="quiz-question__avatar"><img src="/static/img/avatar/default.png"></div>
                <div class="quiz-question__content">
                  <h2 class="quiz-question__title">Пройдите игру и станьте ответственным владельцем</h2>
                  <div class="quiz-question__img">
                    <picture>
                      <source srcset="/static/img/landing/game-cover.webp" type="image/webp">
                      <img src="/static/img/landing/game-cover.png" alt="Обложка игры">
                    </picture>
                  </div>
                </div>
              </div>
              <div class="game__shadow"></div>
            </div>
            <router-link
              to="/quiz"
              class="btn game__btn"
              onclick="sendEventYM(
                 102182679,
                 'start_learning_click_btn'
               );"
            >
            Начать обучение
            </router-link>
          </section>
<!--          <section class="section banner">-->
<!--            <a href="https://kinpet.ru/?utm_source=royalcanin&utm_medium=banner&utm_campaign=school_pp" target="_blank">-->
<!--              <picture>-->
<!--                <source media="(min-width: 1200px)" srcset="/static/img/banner-desktop.jpg">-->
<!--                <img src="/static/img/banner.jpg" alt="Kinpet">-->
<!--              </picture>-->
<!--            </a>-->
<!--          </section>-->
          <section class="section faq">
            <h2 class="section-title">FAQ</h2>
            <div class="faq-list" data-faq>
              <div class="faq-list__item" data-faq-item>
                <div class="faq-list__top" aria-expanded="false">
                  <h3 class="faq-list__title">Сколько раз можно пройти обучение?</h3>
                  <button class="faq-list__btn">
                    <svg class="icon-arrow-down">
                      <use xlink:href="/static/img/sprites/sprite.svg#arrow-down"></use>
                    </svg>
                  </button>
                </div>
                <div class="faq-list__content" aria-hidden="true">
                  <p>Всего предусмотрено 2 обучения: одно по кошкам, второе по собакам. Вы можете пройти обучение по каждой теме один раз. </p>
                </div>
              </div>
              <div class="faq-list__item" data-faq-item>
                <div class="faq-list__top" aria-expanded="false">
                  <h3 class="faq-list__title">Где применить промокод?</h3>
                  <button class="faq-list__btn">
                    <svg class="icon-arrow-down">
                      <use xlink:href="/static/img/sprites/sprite.svg#arrow-down"></use>
                    </svg>
                  </button>
                </div>
                <div class="faq-list__content" aria-hidden="true">
                  <p>Применить промокод можно как в розничных магазинах "Зоозавр", так и в интернет-магазине <a class="accent" href="https://zoozavr.ru/" target="_blank">zoozavr.ru</a></p>
                </div>
              </div>
              <div class="faq-list__item" data-faq-item>
                <div class="faq-list__top" aria-expanded="false">
                  <h3 class="faq-list__title">Сколько промокодов можно получить?</h3>
                  <button class="faq-list__btn">
                    <svg class="icon-arrow-down">
                      <use xlink:href="/static/img/sprites/sprite.svg#arrow-down"></use>
                    </svg>
                  </button>
                </div>
                <div class="faq-list__content" aria-hidden="true">
                  <p>2 промокода - по одному промокоду за каждое обучение. </p>
                </div>
              </div>
              <div class="faq-list__item" data-faq-item>
                <div class="faq-list__top" aria-expanded="false">
                  <h3 class="faq-list__title">На что действует промокод?</h3>
                  <button class="faq-list__btn">
                    <svg class="icon-arrow-down">
                      <use xlink:href="/static/img/sprites/sprite.svg#arrow-down"></use>
                    </svg>
                  </button>
                </div>
                <div class="faq-list__content" aria-hidden="true">
                  <p>
                    Промокод действует на корма Royal Canin (за исключением ветеринарных диет) и на аксессуары для кошек и собак в зоомагазине Зоозавр. С полным списком ассортимента Вы можете ознакомиться по следующим ссылкам:
                    <br/>
                    <a href="https://zoozavr.ru/catalog/index/name/rcstmcats15_zoo_action/" target="_blank" class="accent">Кошки</a>
                    <br/>
                    <a href="https://zoozavr.ru/catalog/index/name/rcstmdogs15_zoo_action/" target="_blank" class="accent">Собаки</a>
                  </p>
                </div>
              </div>
              <div class="faq-list__item" data-faq-item>
                <div class="faq-list__top" aria-expanded="false">
                  <h3 class="faq-list__title">Как я получу Сертификат ответственного владельца и промокод?</h3>
                  <button class="faq-list__btn">
                    <svg class="icon-arrow-down">
                      <use xlink:href="/static/img/sprites/sprite.svg#arrow-down"></use>
                    </svg>
                  </button>
                </div>
                <div class="faq-list__content" aria-hidden="true">
                  <p>Мы отправим Вам сертификат и промокод на покупки в зоомагазине Зоозавр на электронную почту, которую Вы оставите после прохождения обучения. За каждое обучение Вам будет отправлен отдельный Сертификат и промокод.</p>
                </div>
              </div>
            </div>
            <p class="faq-list__after-text">Если у Вас остались вопросы, Вы можете связаться с нами по номеру <a href="tel:+78002003735">+7&nbsp;(800)&nbsp;200-37-35</a>, каждый день с 9:00-21:00 (по МСК)</p>
          </section>
        </div>
      </div>
    </main>
  </div>

  <FooterComponent />
</template>

<script>
import HeaderComponent from '../components/Header/HeaderComponent.vue'
import FooterComponent from '../components/Footer/FooterComponent.vue'

export default {
  name: 'HomePage',
  components: {
    HeaderComponent,
    FooterComponent
  },
  mounted() {
    this.initFAQ();
  },
  methods: {
    initFAQ() {
      const faqList = document.querySelectorAll('[data-faq]');

      if (faqList.length) {
        faqList.forEach(list => {
          const listItem = list.querySelectorAll('[data-faq-item]')

          if (listItem.length) {
            listItem.forEach((item) => {
              item.addEventListener('click', (e) => {
                let self = e.currentTarget;
                let content = self.querySelector('.faq-list__content');
                self.classList.toggle('active');

                if (self.classList.contains('active')) {
                  self.setAttribute('aria-expanded', 'true');
                  content.setAttribute('aria-hidden', 'false');
                  content.style.maxHeight = content.scrollHeight + 'px';
                } else {
                  self.setAttribute('aria-expanded', 'false');
                  content.setAttribute('aria-hidden', 'true');
                  content.style.maxHeight = null;
                }
              })
            })
          }
        })
      }
    }
  }
}
</script>

<style src="../assets/styles/main.scss" lang="scss"></style>

<style scoped lang="scss">
.hero {
  padding-top: 33px;

  @media (min-width: $lg) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 40px;
    margin-bottom: 40px;
  }

  &__content {
    @media (min-width: $lg) {
      margin-top: 30px;
    }
  }

  &__title {
    @include h1;

    margin-top: 0;
    margin-bottom: 16px;
  }

  &__text {
    @include text-1;

    margin-bottom: 32px;
    font-feature-settings: "liga" 0, "clig" 0;
  }

  &__btn {
    margin-bottom: 32px;
    width: fit-content;
  }

  &__img {
    margin: 0 auto;
    max-width: 343px;
    width: 100%;
    height: 100%;

    @media (min-width: $lg) {
      flex-shrink: 0;
      margin-right: 60px;
    }

    &-top {
      margin-bottom: 16px;
      width: 80px;

      @media (min-width: $lg) {
        margin-bottom: 20px;
        width: 120px;
      }
    }
  }
}

.points {
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (min-width: $lg) {
    flex-direction: row;
    flex-wrap: wrap;
  }

  &__item {
    position: relative;
    padding: 14px 16px;
    min-height: 202px;
    background-color: var(--white);
    border-radius: 8px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.05);

    @media (min-width: $lg) {
      padding: 40px 32px;
      min-height: 146px;
      width: calc(100% / 2 - 12px);
    }

    &:nth-child(2) {
      img.points__img {
        right: 11px;
        bottom: 24px;
        max-width: 266px;

        @media (min-width: $lg) {
          right: 20px;
          bottom: 16px;
          max-width: 222px;
          rotate: 0deg;
        }
      }
    }
  }

  &__text {
    @include h2;

    min-width: 218px;
    width: 70%;

    @media (min-width: $lg) {
      width: 73%;
    }
  }

  &__img {
    position: absolute;
    bottom: 0;
    right: 0;
    max-width: 274px;

    @media (min-width: $xl) {
      max-width: 244px;
      right: 42px;
      rotate: -10deg;
    }
  }
}

.themes {
  &__cards {
    display: flex;
    flex-direction: column;
    gap: 16px;

    @media (min-width: $lg) {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;
    }
  }

  &__card {
    position: relative;
    padding: 24px;
    min-height: 378px;
    border-radius: 8px;
    background-color: var(--white);
    overflow: hidden;

    @media (min-width: $lg) {
      min-height: 388px;
    }
  }

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  &__icons {
    display: flex;

    & .icon--rounded.icon--filled {
      outline: 2px solid var(--white);
      z-index: 2;

      &:nth-child(2) {
        margin-left: -1px;
        z-index: 1;
      }
    }
  }

  &__games {
    @include text-16-500;

    color: var(--red);
  }

  &__title {
    @include title-32-500;

    text-transform: uppercase;
  }

  &__img {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 214px;
    object-fit: cover;
  }
}

.landing-group {
  @media (min-width: $lg) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 64px;
  }
}

.game {
  position: relative;
  padding: 24px;
  height: fit-content;
  background-color: var(--red);
  border-radius: 8px;

  @media (min-width: $lg) {
    border-radius: 24px;
  }

  & .section-title {
    margin-bottom: 84px;
    text-align: center;
    color: var(--white);

    @media (min-width: $lg) {
      margin-bottom: 82px;
    }
  }

  &__img {
    position: absolute;
    aspect-ratio: 1 / 1;
    border-radius: 92px;
    border: 5px solid #EA3F51;
    background: var(--white);

    &-1 {
      top: 70px;
      left: 28px;
      width: 62px;
      height: 62px;
      rotate: -33deg;

      @media (min-width: $lg) {
        top: 68px;
        left: 142px;
      }

      &::before {
        content: "";
        position: absolute;
        width: 26px;
        height: 29px;
        top: 32px;
        right: -44px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='26' height='29' viewBox='0 0 26 29' fill='none'%3E%3Cg clip-path='url(%23clip0_281_14867)'%3E%3Cpath d='M13.3009 1.97988C13.3009 1.97988 11.8943 9 10.048 10.719C8.0886 12.4987 2.6474 13.56 2.6474 13.56C2.6474 13.56 7.83461 13.6549 10.3959 16.3243C12.128 18.1272 13.0506 23.242 13.2545 26.3383C13.2545 26.3383 12.8965 18.8806 16.0151 15.4591C17.5047 13.8221 20.7631 12.7662 23.7896 12.6361C23.7896 12.6361 17.2978 12.6217 15.5196 9.71436C13.7413 6.80703 13.3009 1.97988 13.3009 1.97988Z' fill='white'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_281_14867'%3E%3Crect width='19.9743' height='23.3336' fill='white' transform='translate(6.73828) rotate(16.788)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-size: contain;
        z-index: 2;
        rotate: 34deg;

        @media (min-width: $lg) {
          top: 39px;
          right: -54px;
        }
      }

      &::after {
        content: "";
        position: absolute;
        width: 12px;
        height: 13px;
        top: 16px;
        right: -35px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='13' viewBox='0 0 12 13' fill='none'%3E%3Cg clip-path='url(%23clip0_281_14865)'%3E%3Cpath d='M6.09478 0.907145C6.09478 0.907145 5.45029 4.12363 4.60435 4.91125C3.70658 5.72668 1.21353 6.21291 1.21353 6.21291C1.21353 6.21291 3.59021 6.25643 4.76374 7.4795C5.55737 8.30552 5.98008 10.6491 6.07351 12.0677C6.07351 12.0677 5.90946 8.65072 7.33834 7.08304C8.02085 6.33302 9.51379 5.84923 10.9005 5.78962C10.9005 5.78962 7.92607 5.78302 7.11131 4.45093C6.29656 3.11885 6.09478 0.907145 6.09478 0.907145Z' fill='white'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_281_14865'%3E%3Crect width='9.15184' height='10.691' fill='white' transform='translate(3.08789) rotate(16.788)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-size: contain;
        z-index: 2;
        rotate: 34deg;

        @media (min-width: $lg) {
          top: 24px;
          right: -44px;
        }
      }
    }

    &-2 {
      top: 56px;
      right: 26px;
      width: 69px;
      height: 69px;
      rotate: 33deg;

      @media (min-width: $lg) {
        top: 54px;
        right: 138px;
      }

      &::after {
        content: "";
        position: absolute;
        width: 12px;
        height: 13px;
        top: 47px;
        left: -29px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='13' viewBox='0 0 12 13' fill='none'%3E%3Cg clip-path='url(%23clip0_281_14865)'%3E%3Cpath d='M6.09478 0.907145C6.09478 0.907145 5.45029 4.12363 4.60435 4.91125C3.70658 5.72668 1.21353 6.21291 1.21353 6.21291C1.21353 6.21291 3.59021 6.25643 4.76374 7.4795C5.55737 8.30552 5.98008 10.6491 6.07351 12.0677C6.07351 12.0677 5.90946 8.65072 7.33834 7.08304C8.02085 6.33302 9.51379 5.84923 10.9005 5.78962C10.9005 5.78962 7.92607 5.78302 7.11131 4.45093C6.29656 3.11885 6.09478 0.907145 6.09478 0.907145Z' fill='white'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_281_14865'%3E%3Crect width='9.15184' height='10.691' fill='white' transform='translate(3.08789) rotate(16.788)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-size: contain;
        z-index: 2;
        rotate: -3deg;

        @media (min-width: $lg) {
          top: 41px;
          left: -19px;
        }
      }
    }
  }

  & a.btn.game__btn {
    margin-top: 24px;
    color: var(--dark-gray);
    background-color: var(--white);
  }

  &__question {
    position: relative;
    z-index: 1;

    .quiz-question {
      padding: 71px 24px 5px 24px;

      @media (min-width: $lg) {
        padding: 71px 74px 5px 74px;
      }

      &__img {
        @media (min-width: $lg) {
          width: 67%;
        }
      }
    }
  }


  &__shadow {
    position: absolute;
    top: -3px;
    left: 0;
    display: flex;
    width: 100%;
    height: 91%;
    border-radius: 32px;
    background: #EA3F51;
    box-shadow: 0 0 49.6px 0 rgba(0, 0, 0, 0.09);
    rotate: -5deg;
    z-index: -1;
  }
}

.banner {
  border-radius: 24px;
  overflow: hidden;

  @media (min-width: $lg) {
    grid-column: 1 / 3;
    grid-row: 1 / 2;
    margin-bottom: 0;
  }

  &-2 {
    border-radius: 8px;
    overflow: hidden;
  }
}

.faq-list {
  display: flex;
  flex-direction: column;
  gap: 12px;

  &__item {
    padding: 15px;
    border-radius: 8px;
    overflow: hidden;
    background-color: var(--white);
    cursor: pointer;

    &.active {
      .faq-list {
        &__btn {
          & svg {
            rotate: 180deg;
          }
        }

        &__content {
          margin-top: 16px;
        }
      }
    }
  }

  &__top {
    display: flex;
    justify-content: space-between;
    gap: 30px;
  }

  &__title {
    @include h2;
  }

  &__btn {
    flex-shrink: 0;
    width: 26px;
    height: 26px;
    transition: $duration $timing-function;

    & svg {
      width: 100%;
      height: 100%;
      fill: transparent;
    }
  }

  &__content {
    @include text-1;

    box-sizing: content-box;
    max-height: 0;
    overflow: hidden;
    will-change: max-height;
    transition: $duration $timing-function;
  }

  &__after-text {
    margin-top: 20px;
  }
}
</style>
